import { queryOptions } from '@tanstack/react-query'
import { useQueryKeys } from '../hooks'
import { ClientOutputs } from '@botpress/client'
import { getApiClient } from '../stores'

export const listInvoicesQueryOptions = (workspaceId: string) => {
  const client = getApiClient({ workspaceId })
  return queryOptions({
    gcTime: 0,
    queryKey: useQueryKeys().listInvoices(workspaceId),
    queryFn: async (): Promise<ClientOutputs['listWorkspaceInvoices']> =>
      client.listWorkspaceInvoices({ id: workspaceId }),
  })
}
